<template>
  <div class="g_panel feedback" :class="{ 'darkmode': darkMode }" >
    <!-- header -->
    <div class="header g_panel-header">
      <span class="back icon-back" role="button" aria-label="back" tabindex="0" @click.stop="backHandler" />
      <h1 class="title">
        <img :src="require('@/assets/about/logo_s@2x.png')" alt="icon" class="taglogo">
        Feedback
      </h1>
    </div>
    <!-- end header -->
    <div class="feedback-con">
      <div class="form" v-if="!hasSend">
        <input v-model="email" type="text" class="email" :placeholder="$t('feedback.placeholder1')">
        <textarea v-model="msg" resz class="msg" :placeholder="$t('feedback.placeholder2')"></textarea>
        <Btn :loading="loading" class="btn" @click.native="submit" :label="$t('feedback.btn')"></Btn>
      </div>
      <div class="result" v-else>
        <div class="icon icon-check-circle"></div>
        <div class="text">{{$t('feedback.succ')}}</div>
        <div class="back" @click="back">{{$t('feedback.back')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import Btn from '@/components/Btn'

export default {
  components: {
    Btn,
  },
  data() {
    return {
      hasSend: false,
      loading: false,
      msg: '',
      email: '',
    }
  },
  mounted() {
    this.email = this.user.email
  },
  computed: {
    ...mapState({
      show: state => state.feedback.showPanel,
      user: state => state.user.user,
    }),
  },
  methods: {
    ...mapMutations({
      setSizeMode: 'setSizeMode',
      setDarkMode: 'setDarkMode',
      toggleProfilePanel: 'feedback/togglePanel',
    }),
    backHandler() {
      this.$router.back()
    },
    back() {
      this.hasSend = false
      this.msg = ''
    },
    submit() {
      if (!this.email || !/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email)) {
        this.$toast({
          msg: this.$t('feedback.emailErr'),
        })
        return
      }

      if (!this.msg) {
        this.$toast({
          msg: this.$t('feedback.conErr'),
        })
        return
      }
      this.loading = true
      this.$http.post('/feedback/', {
        email: this.email,
        content: this.msg,
      }).then(() => {
        this.hasSend = true
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style lang="scss" scope>
@import '~@/scss/mixin.scss';

.feedback-con{
  padding: 16px;
  width: 600px;
  margin: 0 auto;
  .form{
    .email{
      display: block;
      background: #F0F0F0;
      border: 1px solid #E1E1E1;
      border-radius: 8px;
      font-size: 14px;
      color: #505050;
      height: 36px;
      box-sizing: border-box;
      line-height: 36px;
      padding: 8px 16px;
      width: 100%;
      margin-bottom: 16px;
      @include placeholderMixin(#888888, 14px);
    }
    .msg{
      background: #F0F0F0;
      border: 1px solid #E1E1E1;
      border-radius: 8px;
      font-size: 14px;
      color: #505050;
      height: 36px;
      box-sizing: border-box;
      line-height: 16px;
      padding: 8px 16px;
      width: 100%;
      height: 143px;
      margin-bottom: 16px;
      resize: none;
      @include placeholderMixin(#888888, 14px);
    }
    .btn{
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      width: 100%;
      border-radius: 999px;
      background-image: linear-gradient(180deg, #2E7FFF 0%, #2076FF 100%);
      box-shadow: 0 2px 7px 0 rgba(0,0,0,0.14);
      color: #fff;
      &:hover{
        background-image: linear-gradient(180deg, #2772E9 0%, #216BE0 100%);
      }
    }
  }
  .result{
    .icon{
      font-size: 80px;
      color: #35AF73;
      display: block;
      text-align: center;
      margin: 36px auto 16px;
    }
    .text{
      font-size: 16px;
      color: #646464;
      text-align: center;
      margin-bottom: 8px;
      line-height: 20px;
    }
    .back{
      line-height: 16px;
      font-size: 14px;
      color: #2E7FFF;
      text-align: center;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
}

/* darkmode */
.darkmode{
  .form{
    .msg,
    .email{
      background: #4F4F4F;
      box-shadow: inset 0 0 12px 0 rgba(70,70,70,0.50);
      border: none;
      @include placeholderMixin(#888888, 12px);
      color: #fff;
    }
  }
  .result{
    .text{
      color: #fff;
    }
  }
}
</style>
